export interface DonutSlice {
  id: number;
  percent: number;
  color: string;
  gap?: number;
  label?: string;
  onClick?: () => void;
}
